import React from 'react'
import styled, { css, keyframes } from 'styled-components'
import { bool } from 'prop-types'

import { square } from 'styles/global'
import { black } from 'styles/colors'
import { media } from 'styles/media'
import Icon from 'components/Icon'

import SpinnerIcon from 'icons/spinner.svg'

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const Container = styled.div`
  animation: ${rotate} 1s linear infinite;
  color: ${black};
`

const IconWrap = styled.div`
  display: flex;
  animation: ${rotate} 1s linear infinite;

  > * {
    ${media.medium`
      ${square`28px !important`};
    `};

    ${media.large`
      ${square`32px !important`};
    `};

    ${props =>
      props.isLarge &&
      css`
        ${square`32px !important`};

        ${media.small`
          ${square`40px !important`};
        `};

        ${media.medium`
          ${square`48px !important`};
        `};
      `}
  }
`

const Spinner = ({ isLarge }) => (
  <Container>
    <IconWrap isLarge={isLarge}>
      <Icon icon={<SpinnerIcon />} />
    </IconWrap>
  </Container>
)

Spinner.propTypes = {
  isLarge: bool
}

export default Spinner
